import EditIcon from '@mui/icons-material/Edit';
import pdfIcon from "/pdf-icon.png";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import {AddressBox, DateBox, OrderBox} from "./orders-elements.tsx";
import {ClientCustomerOwnOrder} from "../../model/client-order.ts";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {useMutationEditOrder} from "../../services/api-order.ts";
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import * as React from "react";
import {useEffect} from "react";

const labels = {
  waitingForOffers: 'אנו אוספים הצעות מחיר בשבילך 😎',
  iWantToChange: 'אני רוצה לשנות משהו',
  orderDetails: 'פרטי הובלה',
  error: 'סליחה תקלה :(',
}

export function AwaitingOffersScreen({order}: { order: ClientCustomerOwnOrder }) {
  const [isError, setIsError] = React.useState(false);
  const mutationEditOrder = useMutationEditOrder();
  useEffect(() => {
    if (mutationEditOrder.isPending) {
      setIsError(false);
    } else {
      if (mutationEditOrder.isError) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    }
  }, [mutationEditOrder.isPending]);
  const onClickChangeOrder = async () => {
    setIsError(false);
    const response = await mutationEditOrder.mutateAsync({
      orderId: order.id,
    });
    if (response.newOrderId) {
      window.location.href = `/order/${response.newOrderId}`;
    } else {
      setIsError(true);
    }
  }
  return (
    <OrderBox title={labels['waitingForOffers']}>
      <Stack padding={2} gap={2}>
        <Stack sx={{alignItems: 'center', justifyContent: 'center'}}>
          <DateBox order={order}/>
        </Stack>
        <Divider sx={{
          margin: 2,
        }}/>
        <Stack sx={{alignItems: 'center'}}>
          <AddressBox order={order}/>
        </Stack>
        <Divider sx={{
          margin: 2,
        }}/>
        <Stack direction={'column'} gap={2} sx={{alignItems: 'center', justifyContent: 'space-around'}}>
          {/*<CustomerServiceButton variant={'large'}/>*/}
          <Button>
            <Stack direction={'row'} gap={2} alignItems={'center'} sx={{
              p: 1,
            }}>
              <img src={pdfIcon} style={{
                width: 30,
              }}/>
              <Link sx={{color: '#ffffff', fontSize: 20}} href={order.content.pdfFile}>{labels.orderDetails}</Link>
            </Stack>
          </Button>
          <LoadingButton variant={'outlined'} onClick={onClickChangeOrder} loading={mutationEditOrder.isPending}>
            <Stack direction={'row'} gap={2} alignItems={'center'} sx={{
              p: 1,
            }}>
              <EditIcon/>
              <Typography>{labels.iWantToChange}</Typography>
            </Stack>
          </LoadingButton>
          {
            isError && <Typography sx={{color: 'red', textAlign: 'center'}}>{labels.error}</Typography>
          }
        </Stack>
      </Stack>
    </OrderBox>
  );
}